import { ReactNode } from 'react';
import { CardNewWrapper } from './styles';

type CardNewType = {
  children: ReactNode;
};

export const CardNew = ({ children }: CardNewType) => {
  return <CardNewWrapper>{children}</CardNewWrapper>;
};
